import { DatePicker } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { outputDateFormat } from '../../../../../../../../../../constants/constants'

interface EndDateProps {}

const EndDate: FC<EndDateProps> = () => {
    const name = 'endDate'

    return (
        <Form.Item name={name} label={'Факт. дата отгрузки'}>
            <DatePicker format={outputDateFormat} />
        </Form.Item>
    )
}

export default EndDate
